//@ts-check
import React from 'react';
import IconsContainer from "Utils/IconsContainer";
import Enumerable from "linq";

class Sorting {
    /**
     * @param {SortRule[]} valuesSort 
     * @param {string} fieldName 
     * @returns {SortRule | undefined}
     */
    GetSortOrderValue(valuesSort, fieldName) {
        return valuesSort.find(it => it.fieldName == fieldName);
    }

    /**
     * @param {SortRule[] | null} valuesSort
     * @param {string} fieldName
     */
    GetSortOrderIconParamValuesSort(valuesSort, fieldName) {
        let isDesc = valuesSort == null
            ? null
            : this.GetSortOrderValue(valuesSort, fieldName)?.isDesc ?? null;
        return this.GetSortOrderIcon(isDesc);
    }

    /**
     * @param {boolean | null} isDesc
     */
    GetSortOrderIcon(isDesc) {
        let iconContainerClassName = "table-column-icon-container-sort-direction-" + (isDesc == null ? "none" : isDesc == true ? "desc" : "asc");
        return (
            <div className={"table-column-icon-container " + iconContainerClassName}>
                {isDesc == false
                    ? IconsContainer.Get('ci-sort-arrow-down')
                    : (isDesc == true
                        ? IconsContainer.Get('ci-sort-arrow-up')
                        : IconsContainer.Get('ci-sort-arrow-up-down')
                    )}
            </div>
        );
    }

    /**
     * @param {SortRule[] | null} valuesSort
     * @param {string} fieldName
     */
    SetSortOrderNext(valuesSort, fieldName) {
        if (valuesSort == null)
            return [];

        var sortOrderValue = this.GetSortOrderValue(valuesSort, fieldName);
        if (!sortOrderValue)
            sortOrderValue = {
                fieldName: fieldName,
                isDesc: false
            };

        sortOrderValue.isDesc = !sortOrderValue.isDesc;

        return (
            Enumerable
                .from([sortOrderValue])
                .concat(
                    Enumerable
                        .from(valuesSort)
                        .where(it => it.fieldName != fieldName)
                )
                .toArray()
        );
    }

}

export default new Sorting;